import module from 'nominas/nomina/module.js'

export class NominasNominaExportarMovimientos {
  constructor ($q, $catalogos, NominasNominaMovimientos, NominasNominaSuministro, NominasNominaConceptos) {
    this.$q = $q
    this.$catalogos = $catalogos
    this.NominasNominaMovimientos = NominasNominaMovimientos
    this.NominasNominaSuministro = NominasNominaSuministro
    this.NominasNominaConceptos = NominasNominaConceptos
  }

  get (idEmpresa, idNomina, logotipo, separarSalas, omitir_conceptos_cero, incluir_departamento) {
    return this.$q.all({
        empleados: this.NominasNominaMovimientos.get(idEmpresa, idNomina).then((response) => response.data),
        movimientos: this.$catalogos.get('movimientos'),
        suministro: this.NominasNominaSuministro.get(idEmpresa, idNomina),
        conceptos: this.NominasNominaConceptos.get(idEmpresa, idNomina),
      })
      .then(($resolve) => {
        $resolve.conceptos.map(item => {
          return {
            ID_Concepto: item.ID_Concepto,
            Concepto: item.Concepto,
            total: 0,
          }
        })
        let movimientos = obtenerMovimientos()
        let empleados = obtenerEmpleados(movimientos)
        let departamentos = [null].concat(separarSalas ? obtenerDepartamentos() : [])
        let columnas = obtenerColumnas(movimientos)

        let dep = departamentos.map((item) => {
          item = item === null ? empleados : empleados.filter((empleado) => empleado.departamento === item)
          return item
        })

        if (!incluir_departamento) {
          empleados.forEach((empleado) => (delete empleado.departamento))
        }

        return dep.map((data, index) => {
          return {
            name: (departamentos[index] || 'Nómina ' + idNomina).substr(0, 31),
            details: [],
            columns: columnas,
            options: {
              logo: {
                filename: logotipo,
                title: 'FAN Consultores',
                cell: 'A1',
              },
              show_grid: false,
              fixed_column: 'A8',
            },
            data: data.map((emp) => Object.values(emp)),
          }
        })

        function obtenerMovimientos () {
          let data = []

          $resolve.empleados.forEach((empleado) => {
            ['percepciones', 'deducciones'].forEach((naturaleza) => {
              angular.forEach(empleado[naturaleza], function (value, idConcepto) {
                if (data.indexOf(idConcepto) < 0)
                  data.push(idConcepto)
              })
            })
          })

          return data.map((idConcepto) => {
            return $resolve.movimientos.find((concepto) => {
              return concepto.id == idConcepto
            })
          }).filter((item) => item)
        }

        function obtenerDepartamentos () {
          return $resolve.empleados.reduce((prev, empleado) => {
            return prev.indexOf(empleado.departamento) < 0 ? prev.concat(empleado.departamento ? [empleado.departamento] : []) : prev
          }, [])
        }

        function obtenerEmpleados (movimientos) {
          return $resolve.empleados.map(function (empleado) {

            if (empleado.cobro_carga_social) {
              return null
            }

            let neto = 0
            let suministro = $resolve.suministro.find((item) => item.ID_Empresa === empleado.id_empresa && item.ID_Empleado === empleado.id_empleado)

            let data = {
              id_empresa: empleado.id_empresa,
              id_empleado: empleado.id_empleado,
              empleado: empleado.empleado,
              departamento: empleado.departamento,
              comision_porcentaje: suministro.Comision_Porcentaje || '',
              comision_importe: suministro.Comision_Importe || '',
            }

            movimientos.forEach((concepto) => {
              let movimiento = empleado[concepto.naturaleza === 'P' ? 'percepciones' : 'deducciones'][concepto.id],
                importe = movimiento && movimiento.importe || 0

              let atributo = `g_${concepto.id}`
              data[atributo] = importe

              if (!empleado.cobro_carga_social)
                neto += importe * (concepto.naturaleza === 'P' ? 1 : -1)
            })

            $resolve.conceptos.forEach((item) => {
              let deduccion = suministro.Deducciones[item.ID_Concepto]
              let importe = angular.isNumber(deduccion.editado) ? deduccion.editado : deduccion.calculado

              item.total += importe

              // Total_Deducciones += importe;
              neto -= importe
              let atributo = `h_${item.ID_Concepto}`
              data[atributo] = importe
            })

            data.i_neto = neto
            data.j_impuesto_estatal = empleado.impuesto_estatal
            data.k_carga_social = empleado.carga_social

            return data
          }).filter((item) => item)
        }

        function obtenerColumnas (movimientos) {
          let columnas = []
          columnas.push({label: 'Empr.', format: {align: 'center', width: 4}})
          columnas.push({label: 'Empl.', format: {align: 'center', width: 7}})
          columnas.push({label: 'Nombre', format: {width: 30}})
          if (incluir_departamento) {
            columnas.push({label: 'Dpto.', format: {width: 10}})
          }
          columnas.push({label: '%', format: {type: 'percent', align: 'center', width: 5}})
          columnas.push({label: 'Comision', format: {type: 'currency', align: 'right', width: 10}, totalize: true})

          columnas = [...columnas].concat(movimientos.map((item) => {
            return {label: item.concepto, format: {type: 'currency', align: 'right', width: 10}, totalize: true}
          }))

          columnas = [...columnas].concat($resolve.conceptos.filter((concepto) => {
            if (!concepto.total && omitir_conceptos_cero) {
              empleados.forEach(item => {
                let atributo = `h_${concepto.ID_Concepto}`
                delete item[atributo]
              })
            }

            return !!concepto.total || !omitir_conceptos_cero
          }).map((item) => {
            return {label: item.Concepto, format: {type: 'currency', align: 'right', width: 10}, totalize: true}
          }))

          columnas.push({label: 'Total a pagar', format: {type: 'currency', align: 'right', width: 10}, totalize: true})
          columnas.push({label: 'Impuesto Estatal', format: {type: 'currency', align: 'right', width: 10}, totalize: true})
          columnas.push({label: 'Carga Social', format: {type: 'currency', align: 'right', width: 10}, totalize: true})

          return columnas
        }
      })
  }
}

module.service('NominasNominaExportarMovimientos', NominasNominaExportarMovimientos)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Exportar/Movimientos.js